import React from 'react'
import { FormattedMessage } from 'react-intl'

import { GlobalStyle } from './GlobalStyle'

export const SydDirectoryHeader = () => (
  <>
    <GlobalStyle />
    <div className="mb-2 text-foreground my-body-md">
      <FormattedMessage
        defaultMessage="WELCOME TO SYDNEY AIRPORT"
        id="8yVrRg"
      />
    </div>
    <div className="mb-4 my-heading-2xl">
      <FormattedMessage defaultMessage="Eat, shop &amp; pay" id="ijADA4" />
    </div>
    <div className="mb-6 flex justify-center my-label-md">
      <FormattedMessage
        defaultMessage="Order a selection* of food, drinks, and travel essentials online."
        id="Vnwsq/"
      />
    </div>
    <p className="mb-4 !font-sans my-body-sm">
      <FormattedMessage
        defaultMessage="* For all retail options:"
        id="zBX6Qg"
      />{' '}
      <a
        className="!font-sans text-inherit underline"
        href="https://www.sydneyairport.com.au"
      >
        sydneyairport.com.au
      </a>
    </p>
  </>
)
